<template>
  <v-dialog v-model="model" width="800" persistent :retain-focus="false">
    <v-card class="payment-card">

      <!-- HEADER -->
      <div class="payment-header">

        <div class="tabs">
          <div
            v-for="(item, index) in tabs"
            :key="index"
            class="tab-item"
            :class="{ active: tab === index }"
            @click="tab = index"
          >
            {{ item.label }}
          </div>
        </div>

        <v-btn test-tag="tag-283" icon class="close-btn" @click="model = false">
          <v-icon color="red">mdi-close</v-icon>
        </v-btn>

      </div>

      <!-- BODY -->
      <v-card-text class="text-center">

        <h2 class="mb-2">
          <T>Отправить ссылку на оплату в </T> {{ currentPlatform }}
        </h2>

        <div class="subtitle mb-6">
          <T> Отсканируйте код, чтобы передать платёжную ссылку в </T> {{ currentPlatform }}
        </div>

        <!-- QR через IMG -->
        <div class="qr-wrapper mb-8">
          <v-progress-circular
            v-if="loading_link"
            indeterminate
            size="64"
            width="6"
            color="primary"
          />

          <img
            v-else-if="qrDataUrl"
            :src="qrDataUrl"
            width="300"
            height="300"
            alt="QR Code"
          />

          <div v-else class="text-caption grey--text">
            <T>Не удалось сформировать QR</T>
          </div>
        </div>

        <!-- ACTIONS -->
        <div class="actions" v-if="generatedLink">
          <div class="action-link" @click="openLink">
            <!-- <T>ПЕРЕЙТИ ПО ССЫЛКЕ</T> -->
            <T>ОТПРАВИТЬ ССЫЛКУ В </T> {{ currentPlatform }}
          </div>

          <div class="action-link" @click="copyLink">
            <T>КОПИРОВАТЬ ССЫЛКУ</T>
          </div>
        </div>

      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import QRCode from 'qrcode'

export default {
  props: {
    value: Boolean,
    order: Object
  },
  data(){
    return {
      tab: 1,
      pay_link: null,
      final_link: null,
      qrDataUrl: null,
      loading_link: false,
      tabs: [
        { label: 'WHATSAPP' },
        { label: 'TELEGRAM' }
      ]
    }
  },
  computed:{
    model:{
      get(){ return this.value },
      set(v){ this.$emit('input', v) }
    },
    currentLink(){
      return this.tabs[this.tab].link
    },
    currentPlatform(){
      return this.tabs[this.tab].label
    },
    qrSrc(){
      return `https://api.qrserver.com/v1/create-qr-code/?size=260x260&data=${encodeURIComponent(this.generatedLink)}`
    },
    generatedLink(){
      if (!this.pay_link) return null

      const platform = this.tabs[this.tab].label

      if (platform === 'TELEGRAM') {
        return this.sendPaylinkTelegram()
      }

      if (platform === 'WHATSAPP') {
        return this.sendPaylinkWhatsApp()
      }

      return null
    }
  },

  watch: {
    value: {
      async handler(v) {
        if (v && this.order) {
          this.loading_link = true
          this.final_link = null
          this.qrDataUrl = null

          try {
            const res = await this.payLink(this.order.id)
            this.pay_link = res.href

            this.buildAndGenerateQR()

          } finally {
            this.loading_link = false
          }
        }
      }
    },

    tab() {
      if (this.pay_link) {
        this.buildAndGenerateQR()
      }
    }
  },

  methods:{
    ...mapActions(['payLink']),

    async buildAndGenerateQR() {
      this.final_link = this.buildLink()

      if (!this.final_link) return

      try {
        this.qrDataUrl = await QRCode.toDataURL(this.final_link)
      } catch (e) {
        console.error('QR generation error', e)
      }
    },

    buildLink() {
      const platform = this.tabs[this.tab].label

      if (platform === 'TELEGRAM') {
        return this.sendPaylinkTelegram()
      }

      if (platform === 'WHATSAPP') {
        return this.sendPaylinkWhatsApp()
      }

      return null
    },

    sendPaylinkTelegram() {
      try {
        const guest_phone = this.order?.guest?.phones[0].number.replaceAll(' ', '')

        const message_text = `Здравствуйте, ${this.order?.guest.name}. Для оплаты заказа перейдите по ссылке: ${this.pay_link}`

        const encoded_message_text = encodeURIComponent(message_text)

        const telegram_url = `https://t.me/${guest_phone}?text=${encoded_message_text}`

        return telegram_url
      } catch (err) {
        this.$store.dispatch("showError", {
          isError: true,
          error_text: this.$t("Не удалось отправить")
        })
      }
    },
    sendPaylinkWhatsApp() {
      try {
        const guest_phone = this.order?.guest?.phones[0].number.replaceAll(' ', '')
        const message_text = `Здравствуйте, ${this.order?.guest.name}. Для оплаты заказа перейдите по ссылке: ${this.pay_link}`

        return `https://api.whatsapp.com/send?phone=${guest_phone}&text=${encodeURIComponent(message_text)}`
      } catch (err) {
        this.$store.dispatch("showError", {
          isError: true,
          error_text: this.$t("Не удалось отправить"),
        })
      }
    },
    
    copyLink() {
      const text = this.pay_link

      const textarea = document.createElement('textarea')
      textarea.value = text
      document.body.appendChild(textarea)

      textarea.select()
      textarea.setSelectionRange(0, 99999)

      try {
        document.execCommand('copy')

        this.$store.dispatch('throwTimeoutMessage', {
          message_data: this.$t('Ссылка скопирована'),
          message_class: 'success'
        })
      } catch (err) {
        console.error('Ошибка копирования:', err)

        this.$store.dispatch("showError", {
          isError: true,
          error_text: this.$t("Не удалось скопировать ссылку")
        })
      }

      document.body.removeChild(textarea)
    },
    openLink(){
      window.open(this.generatedLink, '_blank')
    }
  },
  async mounted(){
  }
}
</script>

<style scoped>

.payment-card{
  padding: 20px;
}

.payment-header{
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0 20px 0;
}

.tabs{
  display: flex;
  gap: 80px;
  font-weight: 600;
  letter-spacing: 1px;
  font-size: 18px;
}

.tab-item{
  cursor: pointer;
  color: #999;
  padding-bottom: 8px;
  border-bottom: 3px solid transparent;
  transition: 0.3s;
  text-transform: uppercase;
}

.tab-item.active{
  color: #4CAF50;
  border-color: #4CAF50;
}

.close-btn{
  position: absolute;
  right: 0;
  top: 0;
}

.subtitle{
  color: #666;
  font-size: 14px;
}

.qr-wrapper{
  display: flex;
  justify-content: center;
}

.actions{
  display: flex;
  justify-content: space-around;
  margin-top: 10px;
}

.action-link{
  color: #ff4d4f;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s;
}

.action-link:hover{
  opacity: 0.7;
}

</style>